import { Box, CloseButton, Drawer } from "@mantine/core";
import { FC, useEffect } from "react";
import { ContextModalProps, modals } from "@mantine/modals";
import { useDisclosure } from "@mantine/hooks";
import { store } from 'stores/Store';
import CustomerListTab from "Modules/PractitionersList/ListCustomersTab";
import PractitionersListWithDetails from "../../Modules/PractitionersListWithDetails";

interface Props {
  selectedTab: string;
  customerListTab: string;
  isFullscreen?: boolean;
  noBackNav?: boolean;
  onClose?: () => void;
  onFindOnMap?: (practitioner: any, latLon: [number, number]) => void;
}

const PractitionerListDrawer: FC<ContextModalProps<Props>> = ({
  context, id, innerProps
}) => {
  const [opened, {open, close }] = useDisclosure(false);

  useEffect(() => {
    open();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Drawer
      opened={opened}
      withOverlay={innerProps?.isFullscreen ? false : true}
      zIndex={1000}
      size={innerProps?.isFullscreen ? 'calc(100vh - 70px)' : "calc(100vh - 20px)"}
      transitionProps={innerProps?.isFullscreen ? {
        duration: 0,
      } : {}}
      p={0}
      radius={!innerProps?.isFullscreen ? "30px 30px 0 0": "auto"}
      onClose={() => {
        if (innerProps?.onClose) {
          innerProps?.onClose();
        }
        close();
        context.closeModal(id);
      }}
      position={innerProps?.isFullscreen ? "top" : "bottom"}
      variant="baseball-card"
      styles={{
        header: {
          display: "none",
        },
        body: {
          height: "100%",
          boxSizing: "border-box",
          padding: 0,
        }
      }}
    >
      <Box
        p={0}
        w="100%"
        h="100%"
        pos="relative"
        style={{
          boxSizing: "border-box"
        }}>
        {!innerProps?.isFullscreen && (
          <CloseButton
            size="xl"
            pos="absolute"
            top={25}
            right={10}
            style={{
              zIndex: 5002,
            }}
            onClick={() => {
              if (innerProps?.onClose) {
                innerProps?.onClose();
              }
              close();
              // when there's no back nav, the pracititioner is displayed straight up(e.g. opening baseballCard from map minimenu)
              // therefore we have to clear the currentPractitioner to prevent 
              // it from being displayed when opening the list right after
              // viewing a pin
              if (innerProps?.noBackNav) {
                store.setCurrentPractitioner(null);
              }
              context.closeModal(id);
            }} />
        )}
        <Box pt={innerProps?.isFullscreen ? 25 : 55}
          style={{
            position: "relative",
            boxSizing: "border-box",
            height: "100%",
            padding: "0 20px"
          }}>
            <PractitionersListWithDetails
              defaultTab={innerProps?.selectedTab as CustomerListTab}
              onFindOnMap={innerProps?.onFindOnMap} />
        </Box>
      </Box>
    </Drawer>
  );
};

export const openPractitionerListDrawer = (
  opts: {
    isFullscreen?: boolean,
    noBackNav?: boolean,
    onFindOnMap?: (practitioner: any, latLon: [number, number]) => void;
  },
  selectedTab = CustomerListTab.ALL,
): string => {
  return modals.openContextModal({
    modal: "practitionerListDrawer",
    innerProps: {
      selectedTab: selectedTab || CustomerListTab.ALL,
      isFullscreen: opts?.isFullscreen,
      noBackNav: opts?.noBackNav,
      onFindOnMap: opts?.onFindOnMap,
    },
    withOverlay: false,
    withCloseButton: false,
    variant: "baseball-card",
  });
};

export default PractitionerListDrawer;